import { Checkbox, Col, Form, FormInstance, Row, Select } from 'antd';
import React from 'react';
import { BaseButton, Divider, Gutter, Icon, Flex } from '@common/components';

export function AllowListSelectItem({
  form,
  length,
  index,
  remove,
  roleOptions,
  organizationUnitOptions,
  isAllowedUnitHomeUnit,
  handleChangeHomeUnit,
}: {
  form: FormInstance;
  length: number;
  index: number;
  remove: (index: number) => void;
  isAllowedUnitHomeUnit: (index: number) => boolean;
  handleChangeHomeUnit: (isChecked: boolean, changedIndex: number) => void;
  roleOptions?: { label: string; value: string }[];
  organizationUnitOptions?: { label: string; value: string }[];
}) {
  const validateUniqueAllowedUnit = async (_: unknown, value: string) => {
    if (!value) return;

    const allowedUnits = form.getFieldValue('allowedUnits');
    const unitCount = allowedUnits.filter(
      (allowedUnit: { unit: string }) => allowedUnit.unit === value
    ).length;

    if (unitCount > 1) {
      throw new Error('This unit is already in the list.');
    }
  };

  return (
    <>
      <Gutter size="md" direction="vertical">
        <Row gutter={[16, 0]}>
          <Col span={4}>
            <Gutter direction="top">Unit</Gutter>
          </Col>
          <Col span={20}>
            <Form.Item
              name={[index, 'unit']}
              rules={[
                {
                  required: true,
                  message: 'Please select a unit',
                },
                {
                  validator: validateUniqueAllowedUnit,
                },
              ]}
            >
              <Select
                placeholder="Select Unit"
                size="large"
                options={organizationUnitOptions}
                getPopupContainer={(trigger) => trigger.parentNode}
                showSearch
                optionFilterProp="label"
              />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Gutter direction="top">Roles</Gutter>
          </Col>
          <Col span={20}>
            <Form.Item
              name={[index, 'roles']}
              rules={[
                {
                  required: true,
                  message: 'Please select at least one role',
                },
              ]}
            >
              <Select
                placeholder="Select Roles"
                size="large"
                mode="multiple"
                options={roleOptions}
                getPopupContainer={(trigger) => trigger.parentNode}
                showSearch
                optionFilterProp="label"
              />
            </Form.Item>
          </Col>

          <Col span={12} offset={4}>
            <Form.Item name={[index, 'isHomeUnit']} valuePropName="checked">
              <Checkbox
                disabled={length === 1}
                onChange={(e) => handleChangeHomeUnit(e.target.checked, index)}
              >
                Set as Home Unit
              </Checkbox>
            </Form.Item>
          </Col>

          {!isAllowedUnitHomeUnit(index) && (
            <Col span={8}>
              <Flex justify="end" align="center">
                <BaseButton
                  type="link"
                  icon={<Icon icon="trash" kind="regular" />}
                  onClick={() => remove(index)}
                  danger
                >
                  Remove Unit
                </BaseButton>
              </Flex>
            </Col>
          )}
        </Row>

        <Gutter size="lg" direction="bottom">
          <Divider />
        </Gutter>
      </Gutter>
    </>
  );
}
